import { Layout } from '../../lib/Layout';

export const LAYOUT_CREATOR_ID = Layout.CREATOR;
